import React from 'react';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import ServicesComponent from '../components/Services';
import {useDocTitle} from '../components/CustomHook';
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import { Helmet } from 'react-helmet';


const Home = () => {

    useDocTitle('kesnelDigital - Home');

    return (
        <I18nextProvider i18n={i18n}>
            <Helmet>
                <meta name="description" content="Kesnel Digital designs and builds custom websites, mobile apps and business tools for SMEs and organizations. An independent software studio based in Belfort, France." />
            </Helmet>
            <Hero />
            <Intro />
            <ServicesComponent />
            <Cta/>
            <Footer />
        </I18nextProvider>
    )
}

export default Home;

